import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { injectIntl, FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { countryCode } from 'Helpers/Geo/data';
import FixedImg from 'Components/Utility/FixedImg';

const RegionName = ({
  included,
  excluded,
  countryMessages,
  intl,
  redeemsInMessage,
  shortText,
}) => {
  const { formatMessage } = intl;
  const includedCodes = included.map(country => country.code);
  const excludedCodes = excluded.map(country => country.code);

  let available = true;

  if (!isEmpty(excludedCodes) && excludedCodes.includes(countryCode)) {
    available = false;
  }
  if (!isEmpty(includedCodes) && !includedCodes.includes(countryCode)) {
    available = false;
  }

  if (available) {
    if (shortText) {
      return (
        <div className="region-name">
          <FixedImg
            src={`${countryCode}.png`}
            folder="icons/flags/country-codes/flat/64"
            alt={`${countryCode}flag`}
            className="region-flag"
          />
          <FormattedMessage
            id="regon-name.activatesin"
            defaultMessage="Activates in {countryName}"
            values={{
              countryName: formatMessage(countryMessages[countryCode]),
            }}
          />
        </div>
      );
    }

    return (
      <div className="region-name">
        <FontAwesomeIcon icon={faCircleCheck} className="circle-icon" />
        {redeemsInMessage ? (
          <FormattedMessage
            id="regon-name.redeemin"
            defaultMessage="This product redeems in {countryName}"
            values={{
              countryName: formatMessage(countryMessages[countryCode]),
            }}
          />
        ) : (
          <FormattedMessage
            id="regon-name.activate"
            defaultMessage="This product activates in {countryName}"
            values={{
              countryName: formatMessage(countryMessages[countryCode]),
            }}
          />
        )}
        <FixedImg
          src={`${countryCode}.png`}
          folder="icons/flags/country-codes/flat/64"
          alt={`${countryCode}flag`}
          className="region-flag"
        />
      </div>
    );
  }
  return (
    <div className="region-name">
      <FontAwesomeIcon icon={faCircleXmark} className="circle-icon" />
      {redeemsInMessage ? (
        <FormattedMessage
          id="regon-name.no-redeem"
          defaultMessage="This product will not redeem in {countryName}"
          values={{
            countryName: formatMessage(countryMessages[countryCode]),
          }}
        />
      ) : (
        <FormattedMessage
          id="regon-name.no-activate"
          defaultMessage="This product will not activate in {countryName}"
          values={{
            countryName: formatMessage(countryMessages[countryCode]),
          }}
        />
      )}
      <FixedImg
        src={`${countryCode}.png`}
        folder="icons/flags/country-codes/flat/64"
        alt={`${countryCode}flag`}
        className="region-flag"
      />
    </div>
  );
};

RegionName.propTypes = {
  included: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
    }),
  ),
  excluded: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
    }),
  ),
  countryMessages: PropTypes.shape({}).isRequired,
  redeemsInMessage: PropTypes.bool,
  shortText: PropTypes.bool,
};

RegionName.defaultProps = {
  included: [],
  excluded: [],
  redeemsInMessage: false,
  shortText: false,
};

export default injectIntl(RegionName);
